<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';
    let main;
    let image;
    let text;
    let butt;
    onMount(onStart);
    /**
    
    */
    function onStart() {
        initializeGsapAnimation(main, image, [{filter: 'grayscale(100%) brightness(1.8)',
            transform: 'translate(36.5vw, 0px) scale(5, 1)', duration: 1}, {filter: 'grayscale(0%) brightness(0)',
            transform: 'translate(-40vw, 0px) scale(4, 1)', duration: 1}], 3);
        initializeGsapAnimation(main, text, [{x: '-5vw', duration: 1}, {y: '-15vw', duration: 1}], 3);
        initializeGsapAnimation(main, butt, [{x: '0vw', duration: 1}, {y: '-25vw', duration: 1}], 3);
    }
</script>
<section>
    <div class="maindiv" bind:this={main}>
        <div class="backimg" bind:this={image}>
            <img
                src="/images/createmain/fictionBack.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="info" bind:this={text}>
            <p class="text1">Storytellers & Opus</p>
            <p class="heading">FICTION <br />WRITERS</p>
            <p class="text2" style="padding: 5.607vw 0vw 8.411vw;">
                We’re building a platform that makes producing movies and games
                just as much a collaborative process for everyone as fanfiction
                writing is. More importantly, the derivatives are just as real
                as the original.
            </p>
            <p class="text2" style="font-weight: 700;">
                Fix that ending, join our governing council now!
            </p>
        </div>
        <div class="btn" bind:this={butt}>
            <Mobilebtn width='56.308vw' text='Join Storytellers Governace Council' text2='(Fiction Seat)' state ="Storyteller"/>
        </div> 
    </div>
</section>

<style>
    .maindiv {
        position: relative;
        font-family: "Orbitron";
        z-index: 1;
        overflow: hidden;
    }
    .backimg {
        width: 100%;
        height: max(216.355vw, 100.16vh);
        transform: translate(-20.5vw, 0px)  scale(4, 1);
    }
    p {
        margin: 0;
    }
    .info {
        position: absolute;
        left: 16.916vw;
        top: max(61.215vw, 28.294vh);
    }
    .text1 {
        color: #000000;
        font-weight: 700;
        font-size: 3.271vw;
    }
    .heading {
        color: #a53bd6;
        font-weight: 900;
        font-size: 9.346vw;
    }
    .text2 {
        color: #000000;
        font-weight: 700;
        font-size: 2.804vw;
        line-height: 3.925vw;
        letter-spacing: 0.09em;
        width: 53.037vw;
    }
    .btn{
        position: absolute;
        top: 0;
        padding-top: max(192vw, 88.88vh);
        padding-bottom: max(15vw, 6.944vh);
        width: 100%;
        left: 0;
        right: 0;
    }
</style>
